import './circleLoader.css'
const CircleLoader = () => (
  // <div className="loader-4 center">
  //   <span>hedsdsdsy</span>
  // </div>
  <div className="lds-ripple"><div></div><div></div></div>
)
export default CircleLoader